exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".module-settings {\n  padding: 15px 50px;\n}\n.module-settings .actions-row {\n  margin-top: 20px;\n  text-align: center;\n}\n.module-settings .actions-row button[role=\"primary\"] {\n  margin-left: 10px;\n}\n", ""]);

